export interface IEnergyMeterList {
  ID: number;
  name: string;
  deviceNo: number;
  consumptionType: number;
  W: number;
  VAR: number;
  VA: number;
  kWhi: number;
  kWhe: number;
  powerFactor: number;
  V1: number;
  V2: number;
  V3: number;
  I1: number;
  I2: number;
  I3: number;
  lastUpdate: string;
  wrongDirectionFlag: boolean;
  available: boolean;
  error: number;
}

export interface IEnergyMeterLog {
  name: string;
  energyMeterId: number;
  lastEMLogId: number;
  data: {
    x: string;
    y: number;
  }[];
}

export interface IEnergyMeterHistoryLog {
  ID: number;
  lastLogID: number;
  isLoading: boolean;
  deviceNo: number;
  error?: string;
  data: {
    x: string;
    y: number;
  }[];
}

export interface IEnergyMeterVoltageLog {
  ID: number;
  lastLogID: number;
  deviceNo: number;
  data: {
    x: string;
    v1: number;
    v2: number;
    v3: number;
  }[];
  isLoading: boolean;
  error?: string;
}
// TODO: Change back...
/**
 * export enum Role {
  'Unspecified' = 1,
  'Grid' = 2,
  'Production' = 3,
  'Consumption' = 4,
  'Storage' = 5,
}
 */
export enum Role {
  'Unspecified' = 5,
  'Grid' = 1,
  'Production' = 2,
  'Consumption' = 3,
  'Storage' = 4,
}
